import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import axios from 'axios';

export default function SharedReportPage() {
  const { shareToken } = useParams();
  const [report, setReport] = useState(null);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const base = process.env.REACT_APP_API_URL || '/api';
    axios.get(`${base}/share/${shareToken}`)
      .then(res => {
        setReport(res.data.report);
        setMeta(res.data);
      })
      .catch(() => setError('This report link is invalid or has expired.'))
      .finally(() => setLoading(false));
  }, [shareToken]);

  if (loading) return <div className="min-h-screen bg-white dark:bg-slate-950 flex items-center justify-center h-64 text-slate-400 dark:text-slate-500">Loading shared report…</div>;

  if (error) return (
    <div className="min-h-screen bg-white dark:bg-slate-950">
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <p className="text-red-500 font-medium">{error}</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8 pb-6 border-b border-slate-200 dark:border-slate-700">
        <div className="w-10 h-10 bg-sky-500 rounded-xl flex items-center justify-center">
          <span className="text-white font-bold">HC</span>
        </div>
        <div>
          <p className="font-semibold text-slate-800 dark:text-white">HealthClear AI — Patient Summary</p>
          <p className="text-sm text-slate-400">
            {meta?.patientName && `Patient: ${meta.patientName}`}
            {meta?.reportDate && ` · Report date: ${new Date(meta.reportDate).toLocaleDateString()}`}
          </p>
        </div>
      </div>

      {/* Report */}
      <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-8">
        <div className="prose max-w-none text-slate-700 dark:text-slate-300">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{report}</ReactMarkdown>
        </div>
      </div>

      <p className="text-center text-xs text-slate-400 dark:text-slate-500 mt-6">
        Generated by HealthClear AI · {meta?.generatedAt ? new Date(meta.generatedAt).toLocaleDateString() : ''}<br />
        This summary is for informational purposes only and does not replace medical advice.
      </p>
    </div>
    </div>
  );
}
